// src/components/DialogueBubble.js
import React, { useState, useEffect } from 'react';
import '../App.css';
import { loot } from '../data/loot'; // Fixed import path
import { getQuestsByZone } from '../data/npcInteractions'; // Fixed import path

const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  return input.replace(/[<>&"']/g, (match) => ({
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    "'": '&#x27;',
  }[match]));
};

function DialogueBubble({ npc, onSelectOption, onClose, player, zone }) {
  const [currentDialogue, setCurrentDialogue] = useState(null);
  const [dialogueIndex, setDialogueIndex] = useState(0);
  const [responseIndex, setResponseIndex] = useState(null);

  useEffect(() => {
    if (!npc || !npc.data || !npc.data.dialogue) {
      setCurrentDialogue(null);
      setDialogueIndex(0);
      setResponseIndex(null);
      return;
    }

    // Initialize dialogue
    let dialogue = npc.data.dialogue[dialogueIndex];
    if (responseIndex !== null && dialogue.options[responseIndex]?.response) {
      dialogue = dialogue.options[responseIndex].response[0];
    }

    // Add dynamic quest and trade options
    const zoneQuests = getQuestsByZone(zone.id);
    const availableQuests = zoneQuests.filter(
      (quest) =>
        npc.data.available_quests?.includes(quest.id) &&
        !player.activeQuests.some((q) => q.id === quest.id)
    );
    let options = dialogue.options || [];
    if (availableQuests.length > 0) {
      options = [
        ...options,
        ...availableQuests.map((quest) => ({
          text: `Accept Quest: ${quest.title} (${quest.description})`,
          outcome: 'quest',
          questId: quest.id,
        })),
      ];
    }

    if (npc.data.trade_items && npc.data.trade_items.length > 0) {
      options = [
        ...options,
        ...npc.data.trade_items.map((item) => ({
          text: `Buy: ${item.item_name} (${item.ectoplasm_cost} Ectoplasm)`,
          outcome: 'trade',
          tradeItem: item,
        })),
      ];
      options = [
        ...options,
        {
          text: 'Sell an item from my inventory',
          outcome: 'sell',
        },
      ];
    }

    setCurrentDialogue({ ...dialogue, options });
  }, [npc, dialogueIndex, responseIndex, player, zone]);

  const handleOptionClick = (option, index) => {
    if (option.outcome === 'branch' || option.response) {
      setDialogueIndex(0);
      setResponseIndex(index);
    } else {
      onSelectOption(option);
      if (option.outcome === 'close') {
        setDialogueIndex(0);
        setResponseIndex(null);
      }
    }
  };

  if (!npc || !npc.data || !currentDialogue) return null;

  return (
    <div className="dialogue-bubble">
      <div className="dialogue-header">
        <h4>{sanitizeInput(npc.data.name)}</h4>
        <button className="dialogue-close" onClick={() => { onClose(); setDialogueIndex(0); setResponseIndex(null); }}>
          X
        </button>
      </div>
      <div className="dialogue-content">
        <p>{sanitizeInput(currentDialogue.text)}</p>
        {currentDialogue.options && (
          <ul className="dialogue-options">
            {currentDialogue.options.map((option, index) => (
              <li key={index}>
                <button onClick={() => handleOptionClick(option, index)}>
                  {sanitizeInput(option.text || 'Unknown Option')}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default DialogueBubble;